


	export default {
		name: 'FullScreenLoading',
		setup(){
			return { }
		}
	}
